import { ArrowRight } from "lucide-react";
import { StatusPill } from "./StatusBanner";
import type { Tone } from "../lib/status";

function mapStatus(status: string): Tone {
  const s = status.toLowerCase();
  if (s.includes("active") || s.includes("synced")) return "ok";
  if (s.includes("pause") || s.includes("pending") || s.includes("risk") || s.includes("sim"))
    return "warn";
  return "neutral";
}

export function NetworkMap({
  rows,
}: {
  rows: { leader: string; followers: { name: string; status: string }[] }[];
}) {
  return (
    <div className="network-map">
      {rows.map((row) => (
        <div className="network-row" key={row.leader}>
          <div className="network-leader">
            <strong>{row.leader}</strong>
            <div style={{ marginTop: 8 }}>
              <StatusPill label="Leader" tone="neutral" />
            </div>
          </div>
          <div className="network-arrow" aria-hidden="true">
            <ArrowRight size={16} />
          </div>
          <div className="network-followers">
            <div className="follower-list">
              {row.followers.map((f) => (
                <div key={f.name} style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <span className="mono">{f.name}</span>
                  <StatusPill label={f.status} tone={mapStatus(f.status)} />
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
